import Backbone from "../../libs/backbone/backbone";
import GenericModel from "./generic.model.ts";

export default GenericModel.extend(
{
    urlRoot : 'rest/api/user/dashboard',
    id : null,
    averageWaitTime: 0.0000000,
    maxWaitTime: 0.0000000,
    activeQueuesCount: 0,
    totalVenuesCount: 0,
    dashboardVenue: null,
    dashboardVenues: [],
    dashboardQueues: []
});

